import '../styles/main.css';
import AnimationEngine from './core/animation-engine';
import LazyLoadManager from './core/lazy-load';
import { enableArrowKeyNavigation, setActiveNavigation } from './core/navigation';
import MobileNavigation from './components/mobile-nav';
import ThemeManager from './components/theme-manager';
import initActionButtons from './components/action-buttons';
import initScannerRelease from './components/scanner-release';
import { initTopPlayers } from './components/top-players-rankings';
import initTopRankingTabs from './components/top-ranking-tabs';
import ModalManager from './components/modal';
import initStoreTabs from './components/store-tabs';
import { initForms } from './components/forms';
import { initErrorBoundary } from './utils/error-boundary';
import { initImageErrorHandler } from './utils/error-handlers';

function initApplication() {
  initErrorBoundary();
  initImageErrorHandler();
  setActiveNavigation();
  enableArrowKeyNavigation();
  new ThemeManager().init();
  new MobileNavigation().init();
  new ModalManager().init();
  new AnimationEngine().init();
  new LazyLoadManager().init();
  initStoreTabs();
  initTopRankingTabs();
  initForms();
  initActionButtons();
  initScannerRelease();
  initTopPlayers();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApplication, { once: true });
} else {
  initApplication();
}
